import { render, staticRenderFns } from "./viewUserPage.vue?vue&type=template&id=2edad744&"
import script from "./viewUserPage.vue?vue&type=script&lang=js&"
export * from "./viewUserPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports